import React, { useState } from "react";
import uuid from "react-uuid";
import TableStyles from "../../../../../styles/components/TableStyles";
import { StyledFormCheck } from "../../../../../styles/MainStyles";
import PaginationLocal from "../../../../../components/PaginationLocal";
import {
    IList,
    IModalFilterOptions,
} from "../../../../../context/interfaces/IFilterDataContext";
import { useFilterData } from "../../../../../context/TachContext/FilterDataContext";

interface ITableSelectData {
    keyName: string;
    list: IList[];
}

const TableSelectData: React.FC<ITableSelectData> = ({ keyName, list }) => {
    const [filteredList, setFilteredList] = useState<IList[]>(list);
    const { modalFilterOptions, setModalFilterOptions } = useFilterData();

    const hasValueChecked = (value: IList): boolean => {
        if (!value || !list?.length) return false;

        return modalFilterOptions.tempSelectedValue.some(
            (item) => item.id === value.id
        );
    };

    const handleCheck = (value: IList) => {
        let tempSelectedValue: IList[];

        if (hasValueChecked(value)) {
            tempSelectedValue = modalFilterOptions.tempSelectedValue.filter(
                (item) => item.id !== value.id
            );
        } else {
            tempSelectedValue = [
                ...modalFilterOptions.tempSelectedValue,
                value,
            ];
        }

        const newModalFilterOptions: IModalFilterOptions = {
            ...modalFilterOptions,
            tempSelectedValue,
        };
        setModalFilterOptions(newModalFilterOptions);
    };

    const hasProfessorColumn = modalFilterOptions.key === "professor";

    return (
        <>
            <TableStyles.TablePrimary
                bordered
                striped
                responsive
                style={{ marginBottom: 0 }}
            >
                <thead>
                    <tr>
                        <th>{keyName}</th>
                        {hasProfessorColumn && <th>Matrícula</th>}
                        <th>Adicionar</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredList?.length === 0 ? (
                        <tr>
                            <td colSpan={hasProfessorColumn ? 3 : 2}>
                                Informações indisponíveis.
                            </td>
                        </tr>
                    ) : (
                        filteredList.map((item: IList) => {
                            return (
                                <tr key={uuid()}>
                                    <td>{item.name}</td>
                                    {hasProfessorColumn && (
                                        <td>{item.description}</td>
                                    )}
                                    <td>
                                        <StyledFormCheck
                                            type="checkbox"
                                            id={item.id}
                                            checked={hasValueChecked(item)}
                                            onChange={() => {
                                                handleCheck(item);
                                            }}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </TableStyles.TablePrimary>
            <PaginationLocal
                items={list}
                itemsPage={10}
                onPaginate={(data) => setFilteredList(data)}
                hidePagination={false}
            />
        </>
    );
};

export default TableSelectData;
